import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_32jb4m2ybn: FaireBrandEntity = {
  token: "b_32jb4m2ybn",
  type: "brand",
  name: "True Bloom",
  avatarUrl:
    "https://cdn.faire.com/fastly/16d8dce3ccf1eea3452fcd84f64f0c5f6bd8f840694afe789900231240530b6a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ff127ee17963142d18418f439da9e70fb8afad566e5d877b4fc30c30e452a8b2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/16d8dce3ccf1eea3452fcd84f64f0c5f6bd8f840694afe789900231240530b6a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ff127ee17963142d18418f439da9e70fb8afad566e5d877b4fc30c30e452a8b2.jpeg",
  location: "Holland, MI, USA",
  minimumOrderDollars: 180,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "We are two sisters with a passion for bringing play into a kid’s life, and our own! Between the two of us we have five girls (and one boy!) and they are the inspiration behind the brand. We dreamed up the idea of True Bloom years ago but the timing was never right. But one thing we were taught was to never give up on your dreams and to chase what brings us joy. So here we are, years later with this little dream that came to life. Thank you for being part of our journey!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.588Z",
    importedBy: "entity-db-cli",
  },
};
